import styled, { BoxShadows, Scale, boxShadows } from '@secretescapes/falcon';

export const Container = styled('div')`
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  gap: ${Scale.l};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.white};
  border-radius: ${Scale.xxs};
  box-shadow: ${boxShadows[BoxShadows.level2]};
`;

export const TextBox = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${Scale.xs};
  margin: 0 ${Scale.xl};
`;
